export default __webpack_public_path__ + "static/media/img6.7bb31124.jpg";